import { ForbiddenError } from "@src/features/auth/services/authenticated-fetch";
import { ApiError, ApiTimeoutError } from "@src/services/api/request";
import { LegacyApiError, NetworkError, RateLimitError, ValidationError } from "@src/services/api/legacy-api-request";
const GENERIC = "Something went wrong. Please try again.";
const NETWORK = "Please check your connection and try again.";
const FORBIDDEN = "You don't have permission to perform this action.";

const isUnauthorised = (e: unknown): e is { status: 403 } =>
  e instanceof ForbiddenError ||
  (e instanceof ApiError && e.status === 403) ||
  (e instanceof LegacyApiError && e.status === 403);

const isNetwork = (e: unknown): boolean =>
  e instanceof ApiTimeoutError ||
  e instanceof NetworkError ||
  (e instanceof ApiError && e.status === 0) ||
  (e instanceof LegacyApiError && e.status === 0);

const hasMsg = (e: unknown): e is Error => e instanceof RateLimitError || e instanceof ValidationError;

const rules: ReadonlyArray<(e: unknown) => string | null> = [
  (e) => (isUnauthorised(e) ? FORBIDDEN : null),
  (e) => (isNetwork(e) ? NETWORK : null),
  (e) => (hasMsg(e) ? e.message : null),
];

export function getErrorMessage(error: unknown): string {
  return rules.map((r) => r(error)).find((m) => m !== null) ?? GENERIC;
}
